module.exports = __webpack_public_path__ + "img/cedula.c683af8b.jpeg";